<div class="kraft-table-container">
  <div *ngIf="mode == pageModes.mpListe">
    <a (click)="importMaklerpaket()" *ngIf="importBtAnzeigen"
       class="mini-button" id="importButton"
       mat-button>Neues Paket importieren</a>

    <a (click)="anzeigeTeilpaket()"
       [disabled]="paketBearbeitungDisabled"
       [ngClass]="paketBearbeitungDisabled ? 'mini-button-disabled' : 'mini-button'"
       id="anzeigePaketButton"
       mat-button>Teilpaket anzeigen</a>

    <a (click)="uebergebeTeilpaket()"  *ngIf="uebergabeBtAnzeigen"
       [disabled]="paketBearbeitungDisabledPruefOk"
       [ngClass]="paketBearbeitungDisabledPruefOk ? 'mini-button-disabled' : 'mini-button'"
       id="uebergebePaketButton"
       mat-button>Teilpaket übergeben</a>

    <a (click)="loescheTeilpaket()" *ngIf="loeschenBtAnzeigen"
       [disabled]="paketLoeschenDisabled"
       [ngClass]="paketLoeschenDisabled ? 'mini-button-disabled' : 'mini-button'" id="loeschePaketButton"
       mat-button>Teilpaket löschen!</a>

    <a (click)="zuruecksendenTeilpaket()"  *ngIf="zuruecksendenBtAnzeigen"
       [disabled]="paketBearbeitungDisabledInFreigabe"
       [ngClass]="paketBearbeitungDisabledInFreigabe ? 'mini-button-disabled' : 'mini-button'"
       id="zuruecksendenPaketButton"
       mat-button>Teilpaket zurücksenden</a>

    <a (click)="freigebenTeilpaket()"  *ngIf="freigebenBtAnzeigen"
       [disabled]="paketBearbeitungDisabledInFreigabe"
       [ngClass]="paketBearbeitungDisabledInFreigabe ? 'mini-button-disabled' : 'mini-button'"
       id="freigebenPaketButton"
       mat-button>Teilpaket freigeben</a>


    <a (click)="einspielenTeilpaket()"  *ngIf="einspielenBtAnzeigen"
       [disabled]="paketBearbeitungDisabledFreigegeben"
       [ngClass]="(paketBearbeitungDisabledFreigegeben || paketBearbeitungDisabled) ? 'mini-button-disabled' : 'mini-button'"
       id="einspielenPaketButton"
       mat-button>Teilpaket einspielen</a>

    <a (click)="ablehnenTeilpaket()"  *ngIf="ablehnenBtAnzeigen"
       [disabled]="paketBearbeitungDisabledInFreigabe"
       [ngClass]="paketBearbeitungDisabledInFreigabe ? 'mini-button-disabled' : 'mini-button'"
       id="ablehnenPaketButton"
       mat-button>Teilpaket ablehnen</a>

    <a (click)="loadHistList($event)"
       [disabled]="paketBearbeitungDisabled"
       [ngClass]="paketBearbeitungDisabled ? 'mini-button-disabled' : 'mini-button'"
       id="histListButton"
       mat-button>Historie anzeigen</a>

    <a class="mini-button" id="zurueckButton" mat-button routerLink="/index-kraft">Zurück</a>
  </div>
  <br>

  <!-- Pop-Up-Menu mit Teilpaket-Historie -->
  <div *ngIf="showHistList">
    <app-maklerpaket-kraft-hist-list [id_origin]="id_origin" (showHistList)="isHistListVisible($event)"></app-maklerpaket-kraft-hist-list>
  </div>

  <div *ngIf="mode == pageModes.mpListe">
    <p *ngIf="!_teilpakete" class="label-text_light_blue">Keine Pakete zur Anzeige verfügbar!</p>
    <div *ngIf="_teilpakete" class="table-container">
      <p-table #dt (onRowSelect)="onTeilpaketSelect($event)"
               (onRowUnselect)="onTeilpaketUnselect($event)"
               [(selection)]="selectedTeilpaket"
               [columns]="userinfo.rolle==UserRole.MAKLER?labelTeilpaketeTabelleHeaderMakler:labelTeilpaketeTabelleHeader"
               [paginator]="true" [rows]="15"
               [rowsPerPageOptions]="[15,25,50]"
               [scrollable]="true" scrollHeight="400px"
               [responsive]="true"
               [resizableColumns]="true"
               [value]="_teilpakete"
               sortField="statusdatum" [sortOrder]="-1">
      <ng-template let-columns pTemplate="colgroup">
          <colgroup>
            <col style="width: 3em">
            <col *ngFor="let col of columns; trackBy: trackTeilpaketeTabelle"
                 [style.width]="(longestValueOfCol(col.field) * 6 + 100) + 'px'">
          </colgroup>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <!-- erste Zeile mit Überschrift -->
          <tr>
            <th></th>
            <th *ngFor="let col of columns;  trackBy: trackTeilpaketeTabelle" [pSortableColumn]="col.field"
                pResizableColumn>
              {{col.label}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelAsc="Activate to sort in ascending order"
                          ariaLabelDesc="Activate to sort in descending order"></p-sortIcon>
            </th>
          </tr>
          <!-- zweite Zeile mite Überschrift/Filterfelder -->
          <tr>
            <th></th>
            <th *ngFor="let col of columns;  trackBy: trackTeilpaketeTabelle" [ngSwitch]="col.field">
              <input *ngSwitchCase="'beschreibung'" pInputText type="text" style="width: 120px" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
              <input *ngSwitchCase="'vermittlernummer'" pInputText type="text" style="width: 120px" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
              <p-multiSelect appendTo="body" [style]="{'font-size': '11px'}"
                             *ngSwitchCase="'status'"
                             [options]="statusAllList" defaultLabel="Alle Status"
                             (onChange)="dt.filter($event.value, 'status', 'in')"></p-multiSelect>

            </th>
          </tr>
        </ng-template>
        <ng-template let-rowData pTemplate="body">
          <!-- 0-n Tabellenzeilen mit Teilpaketen -->
          <tr [pSelectableRow]="rowData">
            <td>
              <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
            </td>

            <td *ngIf="selectedTeilpaket != rowData">
              {{rowData.beschreibung}}
            </td>
            <td *ngIf="selectedTeilpaket == rowData" pEditableColumn>
              <p-cellEditor>
                <ng-template  pTemplate="input">
                  <input id="beschreibung" pInputText [(ngModel)]="rowData.beschreibung" type="text" minlength="5" maxlength="50" pattern="^[\-\wäöüÄÖÜß]*$" required
                         title="Keine Sonderzeichen oder Leerzeichen erlaubt! Paketname muss aus mindestens 5 Zeichen bestehen (maximale Länge: 50 Zeichen)!"
                         (change)="changeDone('beschreibung')"
                         (keydown.enter)="changeDone('beschreibung')">
                </ng-template>
                <ng-template pTemplate="output">
                 {{rowData.beschreibung}}
                </ng-template>
              </p-cellEditor>
            </td>

            <td>{{rowData.dateiname}}</td>

            <td *ngIf="selectedTeilpaket != rowData">
              {{rowData.vermittlernummer}}
            </td>
            <td *ngIf="selectedTeilpaket == rowData"  pEditableColumn>
              <p-cellEditor>
                <ng-template  pTemplate="input">
                  <input id="vermittlernummer" pInputText [(ngModel)]="rowData.vermittlernummer" type="text" pattern="^[1-9][0-9]{8}$"
                         title="Vermittler-Nr. muss 9-stellig sein und darf nur aus Ziffern bestehen!"
                         (change)="changeDone('vermittlernummer')"
                         (keydown.enter)="changeDone('vermittlernummer')">
                </ng-template>
                <ng-template pTemplate="output">
                  {{rowData.vermittlernummer}}
                </ng-template>
              </p-cellEditor>
            </td>

            <td>{{rowData.status}}</td>
            <td>{{rowData.statusdatum | date:"dd.MM.yyyy"}}</td>
            <td>{{rowData.loeschdatum | date:"dd.MM.yyyy"}}</td>
            <td>{{rowData.cntTotal | number}}</td>
            <td>{{rowData.cntLocked | number}}</td>
            <td>{{rowData.cntNok | number}}</td>
            <td *ngIf="userinfo.rolle != UserRole.MAKLER">{{rowData.sumVorKh/100 | number:'1.2-2'}}</td>
            <td *ngIf="userinfo.rolle != UserRole.MAKLER">{{rowData.sumVorTk/100 | number:'1.2-2'}}</td>
            <td *ngIf="userinfo.rolle != UserRole.MAKLER">{{rowData.sumVorVk/100 | number:'1.2-2'}}</td>
            <td *ngIf="(userinfo.rolle == UserRole.MAKLERBETREUER || userinfo.rolle == UserRole.PRODUKTGEBER)">{{rowData.sumVorVuSonstige/100 | number:'1.2-2'}}</td>
            <td *ngIf="(userinfo.rolle == UserRole.MAKLERBETREUER || userinfo.rolle == UserRole.PRODUKTGEBER)">{{rowData.sumVorVuInsaUnf/100 | number:'1.2-2'}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div *ngIf="mode == pageModes.mpUpload">
    <app-maklerpaket-upload-kraft (abbruchEvent)="anzeigeMpliste()"
                                  (uploadStatusEvent)="uploadStatus($event)"
                                  [userInfo]="userinfo">
    </app-maklerpaket-upload-kraft>
  </div>

  <div *ngIf="mode == pageModes.mpDetail">
    <app-datatable-kraft
      (abbruchEvent)="anzeigeMpliste()"
      (checkEvent)="loadUpForCheck($event)"
      (saveEvent)="loadUpForSave($event)"
      (einspielenTeilpaketEvent)="einspielenTeilpaketWithId($event)"
      [selectable]="true"
      [values]="_teilpaketDetails"
      [userinfo]="userinfo"
      [(teilpaket)]="selectedTeilpaket">
    </app-datatable-kraft>
  </div>
</div>

<p-dialog header="Hinweis" [(visible)]="displayDialog"
          [responsive]="true" showEffect="fade">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
     Die Daten des Pakets wurden geändert!
      <br><br>Möchten Sie die Änderungen speichern?
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton (click)="paketNichtSpeichern()" label="Nein"></button>
      <button type="button" pButton (click)="paketSpeichern()" label="Ja"></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Teilpaket löschen" [(visible)]="deleteDialog"
          [responsive]="true" showEffect="fade">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      Möchten Sie dieses Paket wirklich löschen?
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" pButton (click)="paketNichtLoeschen()" label="Nein"></button>
      <button type="button" pButton (click)="paketLoeschen()" label="Ja"></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog header="Teilpaket einspielen" [(visible)]="einspielenDialog"
[responsive]="true" showEffect="fade">
<div class="ui-g ui-fluid">
  <div class="ui-g-12">
    Sind Sie sicher, dass Sie dieses Teilpakt einspielen möchten?
  </div>
</div>
<p-footer>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton (click)="paketNichtEinspielen()" label="Nein"></button>
    <button type="button" pButton (click)="paketEinspielen()" label="Ja"></button>
  </div>
</p-footer>
</p-dialog>
